import { NavLink, Outlet } from 'react-router-dom';

import css from './Staff.module.css';


function Staff() {
    return (
        <div className={css.main}>
            <div className={css.menu}>
                <nav className={css.nav}>
                    <NavLink to="/staff/overview">{"<--"}</NavLink>
                </nav>
                {/* <nav className={css.nav}>
                    <NavLink to="/staff/details">Details</NavLink>
                </nav> */}
            </div>
            <Outlet />
        </div>
    );
}

export default Staff;
